import { useSyncExternalStore } from 'react';

// The article image the reader asked to see full size. The renderer only
// opens it; the lightbox lives once, at the panel, so every image shares one
// overlay.
export type KbLightboxImage = {
  src: string;
  alt?: string;
};

let state: KbLightboxImage | null = null;

const listeners = new Set<() => void>();

const setState = (next: KbLightboxImage | null) => {
  state = next;
  listeners.forEach((listener) => listener());
};

export const openKbImage = (image: KbLightboxImage) => {
  setState(image);
};

export const closeKbImage = () => {
  setState(null);
};

const subscribe = (listener: () => void) => {
  listeners.add(listener);

  return () => {
    listeners.delete(listener);
  };
};

/** Escape belongs to the lightbox while an image is open. */
export const isKbLightboxOpen = (): boolean => state !== null;

export const useKbLightbox = (): KbLightboxImage | null =>
  useSyncExternalStore(subscribe, () => state);
